<template>
  <svg
    aria-hidden="true"
    class="h-full w-full"
    role="img"
    viewBox="0 0 24 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Rainbow</title>

    <path
      d="M1.5 13.5 A10.5 10.5 0 0 1 22.5 13.5"
      fill="none"
      stroke="#ef4444"
      stroke-linecap="round"
      stroke-width="2.2"
    />

    <path
      d="M3.7 13.5 A8.3 8.3 0 0 1 20.3 13.5"
      fill="none"
      stroke="#f97316"
      stroke-linecap="round"
      stroke-width="2.2"
    />

    <path
      d="M5.9 13.5 A6.1 6.1 0 0 1 18.1 13.5"
      fill="none"
      stroke="#facc15"
      stroke-linecap="round"
      stroke-width="2.2"
    />

    <path
      d="M8.1 13.5 A3.9 3.9 0 0 1 15.9 13.5"
      fill="none"
      stroke="#22c55e"
      stroke-linecap="round"
      stroke-width="2.2"
    />

    <path
      d="M10.3 13.5 A1.7 1.7 0 0 1 13.7 13.5"
      fill="none"
      stroke="#3b82f6"
      stroke-linecap="round"
      stroke-width="2.2"
    />
  </svg>
</template>
